import React from 'react';
import PropTypes from 'prop-types';
import styles from './ValuesList.module.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
export default function ValuesList(props) {
  const values = props.values.filter((item) => item.value !== undefined);

  return (
    <ul className={styles.container} data-testid={props['data-testid'] || 'container'}>
      {values.map((item) => (
        <li key={item.key} data-testid={`item-${item.key}`}>
          {item.description ? (
            <OverlayTrigger
              key={item.key}
              placement="top"
              overlay={
                <Tooltip id={item.key}>
                  <h5>{item.description}</h5>
                </Tooltip>
              }
            >
              <label>{item.key}</label>
            </OverlayTrigger>
          ) : (
            <label>{item.key}</label>
          )}
          <span>{item.value}</span>
        </li>
      ))}
    </ul>
  );
}

ValuesList.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};
